// AccountForm.js
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Button, Typography } from "@mui/material";
import BankingForm from "../../../../components/form/forms/banking/BankingForm";

export default function AccountForm({ existingAccount, onSave, onCancel }) {
  // Setup form
  const {
    handleSubmit,
    control,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      creditorName: "",
      creditorIBAN: "",
      creditorBIC: "",
      creditorId: "",
      collectionDate: "",
      remittanceInfo: "",
    },
  });

  // If editing an existing account, reset the form with that data
  useEffect(() => {
    if (existingAccount) {
      reset({
        creditorName: existingAccount.creditorName || "",
        creditorIBAN: existingAccount.creditorIBAN || "",
        creditorBIC: existingAccount.creditorBIC || "",
        creditorId: existingAccount.creditorId || "",
        collectionDate: existingAccount.collectionDate || "",
        remittanceInfo: existingAccount.remittanceInfo || "",
      });
    } else {
      // New account => use default blank fields
      reset({
        creditorName: "",
        creditorIBAN: "",
        creditorBIC: "",
        creditorId: "",
        collectionDate: "",
        remittanceInfo: "",
      });
    }
  }, [existingAccount, reset]);

  // Submit handler => calls parent’s onSave
  const onSubmit = (data) => {
    onSave(data);
  };

  return (
    <div style={{ marginTop: "1rem" }}>
      <Typography variant="h6">
        {existingAccount ? "Konto bearbeiten" : "Neues Konto erstellen"}
      </Typography>

      <form onSubmit={handleSubmit(onSubmit)}>
        <BankingForm
          control={control}
          setError={setError}
          clearErrors={clearErrors}
          errors={errors}
        />

        <Button variant="contained" type="submit" sx={{ mt: 2, mr: 2 }}>
          {existingAccount ? "Änderungen speichern" : "Konto erstellen"}
        </Button>

        {onCancel && (
          <Button variant="outlined" sx={{ mt: 2 }} onClick={() => onCancel()}>
            Abbrechen
          </Button>
        )}
      </form>
    </div>
  );
}
